import useI18n from "@/hooks/useI18n";

interface TagAdhesionOfferProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export default function TagAdhesionOffer({
  checked,
  onChange,
}: TagAdhesionOfferProps) {
  const { t } = useI18n();

  return (
    <label className="mt-4 w-full bg-[#F9F9F9] border border-[#E6E6E6] rounded-2xl p-3.5 flex items-center gap-2.5 cursor-pointer">
      <span className="flex-1 min-w-0 flex flex-col gap-0.5">
        <span className="text-sm font-bold font-primary text-text tracking-[-0.1px] leading-[1.4]">
          {t("pages:checkout:tagAdhesionLead")}
        </span>
        <span className="text-sm font-normal font-primary text-tertiary tracking-[-0.1px] leading-[1.4]">
          {t("pages:checkout:tagAdhesionRest")}
        </span>
      </span>
      <span className="relative shrink-0 size-10 flex items-center justify-center">
        <input
          type="checkbox"
          checked={checked}
          onChange={(event) => onChange(event.target.checked)}
          className="absolute inset-0 opacity-0 cursor-pointer"
        />
        {checked ? (
          <img
            src="/svg/icon-checkbox-checked.svg"
            alt=""
            role="presentation"
            width={40}
            height={40}
          />
        ) : (
          <span
            aria-hidden
            className="size-6 rounded border-2 border-[#696966] bg-transparent"
          />
        )}
      </span>
    </label>
  );
}
